export default {
  header: {
    notes: 'Header for listing orders',
    message: 'Orders',
  },
  filter: {
    header: {
      notes: 'Header of filter pane',
      message: 'Filter',
    },
    status: {
      notes: 'Label for status filter',
      message: 'Status',
      all: {
        notes: 'Label for option "all" in status filter',
        message: 'All',
      },
    },
    nothingFoundFilter: {
      notes:
        'If use have filter on and no results where found, this message will show',
      message: 'No orders where found.',
    },
    createdDate: {
      notes: 'Label for created date filter',
      message: 'Created date',
    },
  },
  overLimitMatches: {
    notes:
      'Help text (little i) that are displayed if the number of search hits for orders is over a specific limit',
    message:
      'Your search generated {{limit}} or more matching orders. Please narrow your search by choosing a specific status and/or a shorter interval for date in the filters panel.',
  },
};
